import { CognitoUserPool, AuthenticationDetails, CognitoUser, CognitoUserAttribute } from "amazon-cognito-identity-js"

var poolData = {
  UserPoolId: "eu-west-2_pAGCSJNdj",
  ClientId: "1cpphs5huv5usmfi905ll13l3c"
}
var userPool = new CognitoUserPool(poolData)
var cognitoUser

export default {
  currentUserSession: function() {
    return new Promise((resolve, reject) => {
      cognitoUser = userPool.getCurrentUser()

      if (cognitoUser != null) {
        cognitoUser.getSession(function(err, session) {
          if (err) {
            // alert(err)
            reject(err)
          }

          if (session.isValid()) resolve(cognitoUser)
          else reject("Session invalid")
        })
      } else reject("User null")
    })
  },
  forgotPassword: function(email) {
    cognitoUser = new CognitoUser({
      Username: email,
      Pool: userPool
    })
    return new Promise((resolve, reject) => {
      cognitoUser.forgotPassword({
        onSuccess: function(result) {
          resolve(result)
        },
        onFailure: function(err) {
          reject(err)
        }
      })
    })
  },
  newPassword: function(email, code, newPassword) {
    cognitoUser = new CognitoUser({
      Username: email,
      Pool: userPool
    })

    return new Promise((resolve, reject) => {
      cognitoUser.confirmPassword(code, newPassword, {
        onFailure(err) {
          reject(err)
        },
        onSuccess() {
          resolve()
        }
      })
    })
  },
  changePassword: function(oldp, newp) {
    return new Promise((resolve, reject) => {
      cognitoUser = userPool.getCurrentUser()
      if (cognitoUser != null) {
        cognitoUser.getSession(function(err) {
          if (err) {
            reject(err)
          }
        })
      }

      cognitoUser.changePassword(oldp, newp, function(err, result) {
        if (err) reject(err)
        else resolve(result)
      })
    })
  },
  changeEmail: function(newemail) {
    return new Promise((resolve, reject) => {
      cognitoUser = userPool.getCurrentUser()
      if (cognitoUser != null) {
        cognitoUser.getSession(function(err) {
          if (err) {
            reject(err)
          }
        })
      }

      var attributeList = []
      var attr = {
        Name: "email",
        Value: newemail
      }
      var attribute = new CognitoUserAttribute(attr)
      attributeList.push(attribute)

      cognitoUser.updateAttributes(attributeList, function(err) {
        if (err) {
          alert(err)
          return
        }
      })
    })
  },
  logIn: function(Username, Password) {
    return new Promise((resolve, reject) => {
      var authenticationData = {
        Username,
        Password
      }
      var authenticationDetails = new AuthenticationDetails(authenticationData)

      var userData = {
        Username,
        Pool: userPool
      }

      cognitoUser = new CognitoUser(userData)

      cognitoUser.authenticateUser(authenticationDetails, {
        onSuccess: () => {
          resolve()
        },
        onFailure: err => {
          reject(err)
        },
        newPasswordRequired: () => {
          // store.commit("NEW_PASSWORD_REQUIRED", response)
          reject({ message: "New password required" })
        }
      })
    })
  },
  logOut: function() {
    if (cognitoUser != null) {
      cognitoUser.signOut()
      // cognitoUser.globalSignOut()
    }
  },
  signUp: function(email, password) {
    return new Promise((resolve, reject) => {
      var attributeList = []

      var dataEmail = {
        Name: "email",
        Value: email
      }

      var attributeEmail = new CognitoUserAttribute(dataEmail)

      attributeList.push(attributeEmail)

      userPool.signUp(email, password, attributeList, null, function(err, result) {
        if (err) {
          reject(err)
        } else {
          cognitoUser = result.user
          resolve(result.userSub)
        }
      })
    })
  },
  confirm: function(code) {
    return new Promise((resolve, reject) => {
      cognitoUser.confirmRegistration(code, true, function(err, result) {
        if (err) reject(err)
        else resolve(result)
      })
    })
  }
}
